// Wyzcon Intelligence — Brand Design Tokens
// Single source of truth for all colors, fonts, gradients

const theme = {
  colors: {
    midnight: "#0c0a1d",
    deep: "#1e1b4b",
    darkPurple: "#312e81",
    purple: "#7c3aed",
    violet: "#a78bfa",
    lavender: "#c4b5fd",
    surface: "#13112b",
    card: "#1a1840",
    cardHover: "#211e52",
    border: "#2e2a5e",
    borderLight: "#3d3880",
    text: "#e2e0f0",
    textMuted: "#8b86b0",
    textDim: "#5c577a",
    accent: "#f59e0b",
    red: "#ef4444",
    green: "#4ade80",
    blue: "#60a5fa",
    pink: "#f472b6",
    cyan: "#38bdf8",
    orange: "#fb923c",
    teal: "#34d399",
    fuchsia: "#e879f9",
  },
  gradients: {
    hero: "linear-gradient(135deg, #1e1b4b 0%, #312e81 40%, #7c3aed 100%)",
    card: "linear-gradient(135deg, #1a1840 0%, #211e52 100%)",
    button: "linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)",
    nav: "#0c0a1de0",
  },
  fonts: {
    body: "'Outfit', 'Segoe UI', -apple-system, sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', monospace",
  },
  radii: {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    pill: 20,
    full: "50%",
  },
};

export default theme;
